export default {
    levels: [
        {code: 1, bgColor: '#9627DD', borderColor: '#CD81FF', title: 'Ажлын эхний өдөр'},
        {code: 7, bgColor: '#17A0E2', borderColor: '#31B6FD', title: 'Ажлын эхний 7 хоног'},
        {code: 30, bgColor: '#e04a69', borderColor: '#E63459', title: 'Ажлын эхний 30 хоног'},
        {code: 60, bgColor: '#12A0A1', borderColor: '#32BBBC', title: 'Ажлын эхний 60-90 хоног'},
        {code: 0, bgColor: '#3AC37A', borderColor: '#57DA95', title: 'Бэлтгэл үе'},
    ]
}